"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.promises = promises;
const p_queue_1 = __importDefault(require("p-queue"));
const arrays_1 = require("./arrays");
const constructs_1 = require("./constructs");
/**
 * Translates the input array into an `AsyncArray` object.
 */
function promises(input) {
    const adjusted = new DefaultReifiable(input.map(p => Promise.resolve(p)));
    return new PromisesImpl(adjusted, t => Promise.resolve(t), () => Promise.resolve(true));
}
class PromisesImpl {
    data;
    mapper;
    predicate;
    constructor(data, mapper, predicate) {
        this.data = data;
        this.mapper = mapper;
        this.predicate = predicate;
    }
    map(mapper) {
        return new PromisesImpl(this, (t, i) => Promise.resolve(mapper(t, i)), async () => true);
    }
    filter(predicate) {
        return new PromisesImpl(this, async (t) => t, (u, i) => Promise.resolve(predicate(u, i)));
    }
    async forEach(...args) {
        const len = args.length;
        if (len === 1) {
            await this.map(args[0]).reify();
        }
        else if (len === 2) {
            await this.map(args[1]).reify(args[0]);
        }
        else {
            (0, constructs_1.shouldNeverHappen)(len);
        }
    }
    async reify(concurrency = 16) {
        const ts = await this.data.reify(concurrency);
        // TODO(imaman): pass this queue also when calling this.data.refiy()
        const queue = new p_queue_1.default({ concurrency });
        let captured;
        const pairs = [];
        for (let i = 0; i < ts.length; i++) {
            const t = ts[i];
            queue
                .add(async () => {
                try {
                    const u = await this.mapper(t, i);
                    const b = await this.predicate(u, i);
                    if (b) {
                        pairs.push([u, i]);
                    }
                }
                catch (e) {
                    // TODO(imaman): should capture only the first one.
                    captured = e;
                }
            })
                .catch(e => (captured = e));
        }
        await queue.onIdle();
        if (captured) {
            throw captured;
        }
        return (0, arrays_1.sortBy)(pairs, ([_, i]) => i).map(([u, _]) => u);
    }
}
class DefaultReifiable {
    ps;
    constructor(ps) {
        this.ps = ps;
    }
    async reify() {
        return await Promise.all(this.ps);
    }
}
//# sourceMappingURL=data:application/json;base64,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